import { Component, Input } from '@angular/core';
import { LigneEcartReleve, lignesEcartReleve } from './ecart-releve-bt';

/**
 * Affiche l'écart heures et/ou KM (fin − début) d'un BT dans une seule colonne :
 * vide si données insuffisantes, texte normal si égal, vert + flèche haut si
 * croissance, rouge + flèche bas si baisse. Chaque valeur porte son unité (`12h`, `100km`).
 */
@Component({
    selector: 'app-ecart-releve-bt',
    template: `
        @if (lignes.length > 0) {
            <span class="inline-flex align-items-center gap-2 flex-wrap">
                @for (ligne of lignes; track ligne.unite) {
                    <span class="inline-flex align-items-center gap-1 whitespace-nowrap"
                          [class.text-green-600]="ligne.aCru"
                          [class.text-red-600]="ligne.aBaisse"
                          [attr.aria-label]="ligne.texte">
                        @if (ligne.aCru) {
                            <i class="pi pi-arrow-up text-xs" aria-hidden="true"></i>
                        }
                        @if (ligne.aBaisse) {
                            <i class="pi pi-arrow-down text-xs" aria-hidden="true"></i>
                        }
                        <span>{{ ligne.texte }}</span>
                    </span>
                }
            </span>
        }
    `,
    styles: [`
        :host {
            display: inline-flex;
        }
    `]
})
export class EcartReleveBtComponent {
    @Input() heuresDebut?: number | null;
    @Input() heuresFin?: number | null;
    @Input() kmDebut?: number | null;
    @Input() kmFin?: number | null;

    get lignes(): LigneEcartReleve[] {
        return lignesEcartReleve({
            heuresDebut: this.heuresDebut,
            heuresFin: this.heuresFin,
            kmDebut: this.kmDebut,
            kmFin: this.kmFin
        });
    }
}
